/** CoStar.Api.MarketAnalytics.SearchMarkets.Search.Models.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["BuildingName"] = 4] = "BuildingName";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["Street"] = 6] = "Street";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MatchType[MatchType["BuildingPark"] = 13] = "BuildingPark";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["MultifamilyProperty"] = 21] = "MultifamilyProperty";
    MatchType[MatchType["University"] = 26] = "University";
    MatchType[MatchType["GoogleResults"] = 28] = "GoogleResults";
    MatchType[MatchType["Metro"] = 31] = "Metro";
    MatchType[MatchType["SubmarketCluster"] = 34] = "SubmarketCluster";
    MatchType[MatchType["MSA"] = 35] = "MSA";
    MatchType[MatchType["CoStarProductMarket"] = 132] = "CoStarProductMarket";
})(MatchType || (MatchType = {}));
